export type DiscoveryStage =
  'queued' | 'reading' | 'reviewing' | 'analyzing' | 'complete';
export type DiscoveryJob<T> = {
  id: string;
  websiteUrl: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  stage: DiscoveryStage;
  createdAt: string;
  updatedAt: string;
  deadlineAt: string;
  result: T | null;
  error: string | null;
};
export const discoveryJobActive = (job?: { status: string } | null) =>
  job?.status === 'queued' || job?.status === 'running';
export const discoveryPollInterval = (createdAt: string, now = Date.now()) =>
  now - Date.parse(createdAt) < 30000 ? 3000 : 5000;
